// extracted by mini-css-extract-plugin
export default {"form":"GenerateKey_form__-xj64"};